import { render, staticRenderFns } from "./AnesthetiaForm.vue?vue&type=template&id=3df9bf56&scoped=true"
import script from "./AnesthetiaForm.vue?vue&type=script&lang=js"
export * from "./AnesthetiaForm.vue?vue&type=script&lang=js"
import style0 from "./AnesthetiaForm.vue?vue&type=style&index=0&id=3df9bf56&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3df9bf56",
  null
  
)

export default component.exports